/**
 * @Description 图例-点位名称开关
 */

import { FC } from 'react';
import { Switch } from 'antd';
import cs from 'classnames';
import styles from './index.module.less';

import { useMethods } from '@lhb/hook';

interface PointNameSwitchProps {
  checked: boolean;
  isYouthMap?: boolean;
  onChange: (val: boolean) => void;
}

/**
 * @Description 图例-点位名称开关
 */
const PointNameSwitch: FC<PointNameSwitchProps> = ({
  checked,
  isYouthMap = false,
  onChange
}) => {

  const methods = useMethods({
    handleChange(val: boolean) {
      onChange(val);
    },
  });

  return (
    <div className={styles.legendItemCon}>
      <div className={styles.iconCon}>
        <img
          src={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/map/point_selected.png`}
          width='100%'
          className={styles.iconCon}
        />
        <div className={styles.textCon}>点</div>
      </div>
      <div className={cs(styles.nameCon, 'c-333 fs-12')}>
        {isYouthMap ? '商圈' : '点位'}名称
      </div>
      <div>
        <Switch
          checked={checked}
          size='small'
          onChange={methods.handleChange}
        />
      </div>
    </div>
  );
};

export default PointNameSwitch;
